// table-head — wireframe skin module (RUN-407: native table redesign)
// Configuration node; host is hidden. run-table renders <thead> directly.

export const styles = `
  :host {
    display: none;
  }
`;

export function render(host) {
  host.shadowRoot.innerHTML = `<slot></slot>`;
}
